import { useFeatureFlags } from '@node-space/hooks'
import { AccountContactTypes } from '../helpers/constants'
import { AccountContactData, AccountContactType } from '../helpers/types'

export const useAccountContactList = (accountContactList: AccountContactData[]) => {
  const { enableContactController } = useFeatureFlags()

  const hasIndividualBusinessOwner = accountContactList?.some(
    ({ type, person }) => type === AccountContactTypes.BUSINESS_OWNER && !!person
  )

  const isControllerRequired = !!enableContactController && !hasIndividualBusinessOwner

  const getHasControllerDirector = () => {
    return accountContactList?.some(
      ({ type, controllerInfo }) =>
        type === AccountContactTypes.BUSINESS_DIRECTOR && !!controllerInfo
    )
  }

  const getContactStepStatus = (contactType: AccountContactType) => {
    if (isControllerRequired && contactType === AccountContactTypes.BUSINESS_DIRECTOR) {
      return getHasControllerDirector()
    }
    return accountContactList?.some(({ type }) => type === contactType)
  }

  return { isControllerRequired, getContactStepStatus, getHasControllerDirector }
}
